<template>
	<div>
		<w-card
			:tile="true"
			shadow
			class="xs12 md12 lg12 xl12 primary mt1 pa0 titleCard"
			v-for="darsa in darsaList"
			:key="darsa.id"
		>
			<p>
				<w-icon class="mr1">wi-check</w-icon>
				<span style="width: 100px;">{{ darsa.mada }}</span>
				<i class="red ml3">( {{ darsa.muda }} )</i>
				<i class="cyan ml3">( {{ darsa.place }} )</i>
			</p>
			<div
				class="setting info-dark2--bg white edit"
				@click="editDarsa(darsa)"
			>
				<i class="mdi mdi-pencil"></i>
			</div>
			<div
				class="setting error--bg white delete"
				@click="deleteConfirm(darsa)"
			>
				<i class="mdi mdi-delete"></i>
			</div>
		</w-card>
		<site-loader
			:noresult="progress == 0"
			:loading="progress == 1"
		></site-loader>
		<confirm
			:show="showConfirm"
			:btnLoad="isDeleting"
			@on-confirm="deleteDarsa"
		/>
	</div>
</template>
<script>
import axios from 'axios';
import confirm from '../confirm.vue';
export default {
	components: { confirm },
	props: ['isChanged'],
	emits: ['edit-darsa'],
	data() {
		return {
			darsaList: [],
			progress: null,
			showConfirm: false,
			toDelete: null,
			isDeleting: false,
		};
	},
	methods: {
		async getDarsa() {
			this.progress = 1;
			try {
                var form = new FormData();
                form.append('status','all');
				const response = await axios.post('darsa.php', form);
				let res = response.data.status;
				this.darsaList = res == 200 ? response.data.data : [];
				// alert(JSON.stringify(response))
				this.progress = null;
			} catch (error) {
				this.progress = null;
				console.log(error);
			}
		},
		editDarsa(darsa) {
			this.$emit('edit-darsa', darsa);
		},
		deleteConfirm(darsa) {
			this.showConfirm = true;
			this.toDelete = darsa;
		},
		deleteDarsa(result) {
			if (result) {
				this.isDeleting = true;
				var formData = new FormData();
				formData.append('status', -1);
				formData.append('darsaId', this.toDelete.id);
				formData.append('pahala', '');
				formData.append('title', '');
				formData.append('siku', '');
				formData.append('muda', '');
				axios
					.post(
						'darsa.php',
						formData
					)
					.then((data) => {
						this.showConfirm = false;
						this.isDeleting = false;
						let result = data.data;
						if (result.status == 200) {
							this.getDarsa();
						} else {
							alert('Fail To Delete');
						}
					})
					.catch((error) => {
						this.showConfirm = false;
						this.isDeleting = false;
						alert('Fail To Delete\n ' + error);
					});
			} else {
				if (!this.isDeleting) {
					this.showConfirm = false;
				}
			}
		},
	},
	watch: {
		isChanged() {
			this.darsaList = [];
			this.getDarsa();
		},
	},
	mounted() {
		this.getDarsa();
	},
};
</script>
<style scoped></style>
